
import React, { Component } from 'react'

class NaviIconMenu extends Component {
  onNaviBarClicked (url, e) {
    e.preventDefault()
    this.props.history.push(url)
  }
  renderNaviIcon () {
    return this.naviIconSetting.map((navi, index) => {
      return (
        <li key={'nave' + index} className='kw-btn-area'>
          <a onClick={(e) => this.onNaviBarClicked(navi.url, e)} >
            <i className={navi.iconClass} /><span>{navi.title}</span>
          </a>
        </li>
      )
    })
  }
  render () {
    const naviIcon = this.renderNaviIcon()
    return (
      <div className='body-nav body-nav-horizontal body-nav-fixed'>
        <div className='container'>
          <ul>
            {naviIcon}
          </ul>
        </div>
      </div>
    )
  }
}

export default NaviIconMenu



// WEBPACK FOOTER //
// ./src/common/component/NaviIconMenu.js